import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Country } from 'src/app/countriesConfig';
import { JOURNEY_GUIDE_COPY } from 'src/app/onboarding-checklist/activation-journey.service';
import { ContactPhoneCaptureService } from 'src/app/onboarding-checklist/contact-phone-capture.service';

export type WhatsAppDailySummaryModalResult = 'saved' | 'snoozed';

@Component({
  selector: 'app-whatsapp-daily-summary-modal',
  templateUrl: './whatsapp-daily-summary-modal.component.html',
  styleUrls: ['./whatsapp-daily-summary-modal.component.css'],
  standalone: false,
})
export class WhatsAppDailySummaryModalComponent {
  readonly copy = JOURNEY_GUIDE_COPY;
  countries: Country[] = [];
  dialCode = '+91';
  national = '';
  status: 'idle' | 'saving' | 'invalid' | 'error' = 'idle';

  constructor(
    private dialogRef: MatDialogRef<
      WhatsAppDailySummaryModalComponent,
      WhatsAppDailySummaryModalResult
    >,
    private contactPhoneCapture: ContactPhoneCaptureService,
    private snackBar: MatSnackBar
  ) {
    this.countries = this.contactPhoneCapture.getCountries();
    this.dialCode = this.contactPhoneCapture.defaultDialCode;
  }

  get dialDisplay(): string {
    const match = this.countries.find((c) => c.dialCode === this.dialCode);
    if (match) {
      return `${match.code} ${match.dialCode}`;
    }
    return this.dialCode || '+91';
  }

  get canSave(): boolean {
    const composed = this.contactPhoneCapture.composeE164(this.dialCode, this.national);
    return (
      !!composed &&
      this.contactPhoneCapture.isValidPhone(composed) &&
      this.status !== 'saving'
    );
  }

  save(): void {
    const composed = this.contactPhoneCapture.composeE164(this.dialCode, this.national);
    if (!composed || !this.contactPhoneCapture.isValidPhone(composed)) {
      this.status = 'invalid';
      return;
    }
    this.status = 'saving';
    this.contactPhoneCapture.savePhone(composed, 'daily_popup').subscribe({
      next: () => {
        this.dialogRef.close('saved');
      },
      error: (err) => {
        if (err?.message === 'invalid_phone') {
          this.status = 'invalid';
          return;
        }
        this.status = 'error';
        this.snackBar.open('Could not save mobile number. Try again.', 'OK', {
          duration: 4000,
        });
      },
    });
  }

  snooze(): void {
    if (this.status === 'saving') {
      return;
    }
    this.dialogRef.close('snoozed');
  }
}
